import { useState, useCallback } from 'react';

/**
 * Custom hook for managing modal open/close state
 * @param {boolean} initialState - Initial open state (default: false)
 * @returns {object} Modal state and control functions
 */
function useModal(initialState = false) {
  const [isOpen, setIsOpen] = useState(initialState);

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const toggle = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  return {
    isOpen,
    open,
    close,
    toggle,
    setIsOpen, // For cases where you need direct control
  };
}

export default useModal;
